import styled from "styled-components"

export const RightSideIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  gap: 2px;
`
